import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import guardianDashboardService from '../services/guardianDashboardService';
import { toast } from 'react-toastify';
import styles from '../assets/recommendFriendThanks.module.css';

const RecommendFriendThanks = () => {
  const [thankYouData, setThankYouData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadThankYouData();
  }, []);

  const loadThankYouData = async () => {
    try {
      const response = await guardianDashboardService.getRecommendFriendThanks();
      setThankYouData(response.data);
    } catch (error) {
      console.error('Error loading thank you page:', error);
      toast.error('Failed to load page content');
      // Redirect back to dashboard on error
      navigate('/guardian-dashboard');
    } finally {
      setLoading(false);
    }
  };

  const handleReturnHome = () => {
    navigate('/guardian-dashboard');
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Loading...</div>
      </div>
    );
  }

  if (!thankYouData) {
    return (
      <div className={styles.container}>
        <div className={styles.error}>Failed to load page content</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {/* Laravel exact structure: parts.boxes._general_message */}
      <div className={styles.generalMessage}>
        <div className={styles.messageHeader}>
          {thankYouData.message_header}
        </div>
        <div className={styles.messageTitle}>
          {thankYouData.message_title}
        </div>
        <div className={styles.messageDescription}>
          {thankYouData.message_description}
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.colMd12}>
          <div className={styles.panelGroup}>
            <div className={styles.row}>
              <div className={styles.colXs12}>
                
                {/* What Happens Next Section */}
                <h3 className={styles.sectionTitle}>What Happens Next?</h3>
                {thankYouData.whatHappensNext?.map((step, index) => (
                  <p key={index} className={styles.stepText}>
                    {step}
                  </p>
                ))}

                {/* Why Recommend a Friend Section */}
                <h3 className={styles.sectionTitle}>
                  {thankYouData.whyRecommend?.title}
                </h3>
                <p className={styles.description}>
                  {thankYouData.whyRecommend?.description}
                </p>
                <ul className={styles.benefitsList}>
                  {thankYouData.whyRecommend?.benefits?.map((benefit, index) => (
                    <li key={index} className={styles.benefitItem}>
                      {benefit}
                    </li>
                  ))}
                </ul>

                {/* Benefits for Your Friend Section */}
                <h3 className={styles.sectionTitle}>
                  {thankYouData.benefitsForFriend?.title}
                </h3>
                <p className={styles.description}>
                  {thankYouData.benefitsForFriend?.description}
                </p>
                <ul className={styles.benefitsList}>
                  {thankYouData.benefitsForFriend?.benefits?.map((benefit, index) => (
                    <li key={index} className={styles.benefitItem}>
                      {benefit}
                    </li>
                  ))}
                </ul>

                {/* Thank You Message */}
                <h3 className={styles.sectionTitle}>
                  Thank You for Being Part of Our Mission
                </h3>
                <p className={styles.description}>
                  We value your involvement in helping us create better living environments. 
                  If you have any questions or need further information, please click on the 
                  'Have a query' tab at the top of this page.
                </p>
                <p className={styles.description}>
                  Together, we can make a difference, one property at a time.
                </p>

                {/* Return to Home Button - Laravel exact structure */}
                <button 
                  className={`${styles.btn} ${styles.btnSecondary} ${styles.mr2}`}
                  onClick={handleReturnHome}
                >
                  Return To Home
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendFriendThanks;




